import { render, staticRenderFns } from "./TFragenIcon.vue?vue&type=template&id=e4c801c8"
import script from "./TFragenIcon.vue?vue&type=script&lang=js"
export * from "./TFragenIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports